export default __webpack_public_path__ + "static/media/third-right-img.742f06dd.png";